import { render } from "./DireccionesComponent.vue?vue&type=template&id=90505ab6"
import script from "./DireccionesComponent.vue?vue&type=script&lang=js"
export * from "./DireccionesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__